import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

/**
 * Функция сохранения данных по связям
 */
export const useObjectTypesEdgesCreate = () => {
  const http = useHttp()

  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.post(`/types/${data.from_type_id}/links`, data)
    },
  })

  const create = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.object_types_edges_created'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    create,
  }
}
